import { getEduLoginUrl } from '../api/cgi/common';
import message from '@/utils/message';

const NO_PHONE_ERROR_C0DE = 520;

/**
 * @description 授权营销学堂
 */
export function authEdu({ company_id, user_id }) {
  if (!window.sessionStorage.getItem('edu_login_token')) {
    return getEduLoginUrl({
      data: {
        company_id,
        user_id,
      },
    }).then((res) => {
      if (res.code === 0) {
        const href = `${res.data.edu_login_url}&callBackUrl=${encodeURIComponent(location.href)}`;
        window.sessionStorage.setItem('edu_login_token', href);
        window.location.href = href;
        return Promise.resolve();
      } if (res.code === NO_PHONE_ERROR_C0DE) {
        message.error('请先绑定手机号！否则可能会无法阅读知识库文章。');
        return Promise.reject();
      }
      // 对于未在营销学堂注册的用户跳转营销学堂的注册页面
      message.error('营销学堂授权失败，将无法观看视频，请绑定手机号');
      return Promise.reject();
    });
  }
  return Promise.resolve();
}
